import noNilArray from 'utils/arrays/noNilArray.util';

const rankMatchesAtStartOfFragmentsCount = (options) => {
  const strings = noNilArray(options?.strings);
  const text = options?.text;

  // 1 point for each match at start of any fragment
  let points = 0;
  for (let i = 0; i < strings.length; i += 1) {
    points += strings[i].startsWith(text) ? 1 : 0;
  }
  return points;
};

export default rankMatchesAtStartOfFragmentsCount;
